import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/theme/index.css';

if (process.env.NODE_ENV != 'development') {
  console.log = function () { }
  console.warn = function () { }
}

Vue.config.productionTip = false

Vue.prototype.$title = '捷晨云选片';
Vue.prototype.$version = 'V2.0.8';
Vue.prototype.$beian = '滇ICP备19004889号-1';
Vue.prototype.$captcha = 'aliyun';//self or aliyun
Vue.prototype.$qrcode_src = 'https://xpjckj.cn/qrcode.php?data=';//encodeURIComponent(xplink)

Vue.use(ElementUI, {
  size: 'small'
});


new Vue({
  render: h => h(App),
}).$mount('#app')
